export default "__VITE_ASSET__KEXm3$cI__"